import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_ever_responsible_for_the_cost_of_any_of_the_following'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_ever_responsible_for_the_cost_of_any_of_the_following',
  name: 'Are workers ever responsible for the cost of any of the following?',
  description:
    'The intent of this question is to understand if the facility charges for the cost of the items below. \r\r\n\r\r\nCharging for either the NEW cost (when the item is first provided) or REPLACEMENT cost (when the item is lost stolen or damaged). \r\r\n\r\r\nThe question is tied to the "deposits" question in Recruitment and Hiring section. If the facility charges for these items, but then gives the money back after the item has been returned, it is considered a deposit, NOT a charge.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'IDS_BADGES_SWIPE_CARDS',
      text: 'IDs/Badges/Swipe Cards',
      externalIds: [
        {
          id: 'wb-20-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'UNIFORMS',
      text: 'Uniforms',
      externalIds: [
        {
          id: 'wb-20-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'wb-20-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wb-20-3f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'wb-20-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: ['IDS_BADGES_SWIPE_CARDS', 'UNIFORMS', 'OTHER', 'NONE_OF_THE_ABOVE'],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-49',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8920,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
